import { tss } from 'tss-react/mui';

export const useServicesStyles = tss.withName('ServicesSection').create(({ theme }) => ({
    section: {
        backgroundColor: theme.palette.ink.main,
        color: theme.palette.ink.contrastText,
        padding: theme.spacing(14, '6%'),
    },
    inner: {
        maxWidth: '1400px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: '4fr 8fr',
        gap: theme.spacing(8),
        [theme.breakpoints.down('md')]: {
            gridTemplateColumns: '1fr',
            gap: theme.spacing(5),
        },
    },
    eyebrow: {
        color: theme.palette.primary.main,
        display: 'block',
        marginBottom: theme.spacing(2.5),
    },
    intro: {
        color: theme.palette.fog,
        marginTop: theme.spacing(2.5),
        maxWidth: 320,
    },
    list: {
        borderTop: `1px solid ${theme.palette.lineOnDark}`,
    },
    row: {
        display: 'grid',
        gridTemplateColumns: '3fr 5fr',
        gap: theme.spacing(4),
        padding: theme.spacing(4, 0),
        borderBottom: `1px solid ${theme.palette.lineOnDark}`,
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr',
            gap: theme.spacing(1.5),
        },
    },
    index: {
        color: theme.palette.fog,
        marginRight: theme.spacing(2),
    },
    rowTitle: {
        display: 'flex',
        alignItems: 'baseline',
    },
    rowDescription: {
        color: theme.palette.fog,
        maxWidth: 480,
    },
}));
